import { useCallback } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import axios from 'axios';

export default function useAdminApi() {
    const { getAccessTokenSilently } = useAuth0();
    return useCallback(
        async (path, { method = 'GET', body, pdf = false } = {}) => {
            const base = process.env.NODE_ENV === 'production' ? 'https://api.mrreedsteamlab.com' : '';
            try {
                const token = await getAccessTokenSilently();
                const response = await axios({
                    url: `${base}/api/admin${path}`,
                    method,
                    data: body,
                    headers: { Authorization: `Bearer ${token}` },
                    responseType: pdf ? 'blob' : 'json',
                });
                return response.data;
            } catch (error) {
                let details = error.response?.data;
                if (details instanceof Blob) {
                    try {
                        details = JSON.parse(await details.text());
                    } catch {
                        details = null;
                    }
                }
                const message = axios.isAxiosError(error)
                    ? details?.message || 'Unable to complete the request. Refresh the record before retrying.'
                    : error.message;
                throw Object.assign(new Error(message), {
                    cause: error,
                    status: error.response?.status,
                    code: error.code || error.error,
                });
            }
        },
        [getAccessTokenSilently],
    );
}
